import type { NextPageWithAddons } from 'next';

import Consent from '@paid-ui/blocks/global-dialog/Consent';
import { SignUpForm } from '@paid-ui/forms/sign-up';
import { SignContainer } from '@paid-ui/layouts/sign';

const SignUpPage: NextPageWithAddons = () => {
  return (
    <SignContainer
      title="Sign up"
      description="Join the construction industry's safest payment platform"
    >
      <SignUpForm />
      <Consent />
    </SignContainer>
  );
};

SignUpPage.layout = (page) => <div>{page}</div>;

export default SignUpPage;
